import { useEffect, useRef } from 'react';

export const useScrollReveal = (stagger = 0) => {
  const elementRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Adiciona um pequeno delay se houver stagger
            setTimeout(() => {
              entry.target.classList.add('reveal-visible');
            }, stagger);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
    );

    if (elementRef.current) {
      observer.observe(elementRef.current);
    }

    return () => observer.disconnect();
  }, [stagger]);

  return elementRef;
};